export default __webpack_public_path__ + "static/banner7_mobile-0ef37d92da1d0d038f2d3088b4f6d6e8.png";